// Örnek servis codiagno login
import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "/v1/new-members";

export default {
  /**
   * Yeni bir üye ekler.
   *
   * @param {Object} body - Yeni üye bilgileri
   * @param {string} body.Title - Üyenin başlığı
   * @param {string} body.Description - Üyenin açıklaması
   * @param {string} body.Username - Üyenin kullanıcı adı
   * @param {number} body.PhotoFileId - Üyenin fotoğraf dosya ID'si
   * @param {string} body.Position - Üyenin pozisyonu
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  addNewcomer(body) {
    return axios.post(`${RESOURCE_NAME}`, body);
  },

  /**
   * Bir kullanıcıyı günceller.
   *
   * @param {Object} body - Yeni üye bilgileri
   * @param {string} body.Title - Üyenin başlığı
   * @param {string} body.Description - Üyenin açıklaması
   * @param {string} body.Username - Üyenin kullanıcı adı
   * @param {number} body.PhotoFileId - Üyenin fotoğraf dosya ID'si
   * @param {string} body.Position - Üyenin pozisyonu
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  updateNewcomer(body) {
    return axios.put(`${RESOURCE_NAME}/update`, body);
  },

  /**
   * Yeni üyeleri listeler (sayfalı).
   *
   * @param {number} page - Sayfa numarası
   * @param {number} pageSize - Sayfa başına eleman sayısı
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  getNewcomers(page, pageSize) {
    return axios.get(`${RESOURCE_NAME}`, {
      params: { page, pageSize }
    });
  },

  /**
   * Belirtilen ID'ye sahip yeni üyeyi siler.
   *
   * @param {number|string} id - Silinecek üyenin ID'si
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  deleteNewcomer(id) {
    return axios.put(`${RESOURCE_NAME}/delete/${id}`);
  },
};
